export function bootstrapTemplate() {
  // Global variables
  let userAgent = navigator.userAgent.toLowerCase(),
    isIE =
      userAgent.indexOf("msie") !== -1
        ? parseInt(userAgent.split("msie")[1], 10)
        : userAgent.indexOf("trident") !== -1
        ? 11
        : userAgent.indexOf("edge") !== -1
        ? 12
        : false;

  // Unsupported browsers
  if (isIE !== false && isIE < 12) {
    console.warn("[Core] detected IE" + isIE + ", load alert");
    var script = document.createElement("script");
    script.src = "./js/support.js";
    document.querySelector("head").appendChild(script);
  }

  let initialDate = new Date(),
    $document = $(document),
    $window = $(window),
    $html = $("html"),
    $body = $("body"),
    isDesktop = $html.hasClass("desktop"),
    isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ),
    windowReady = false,
    isNoviBuilder = false,
    livedemo = false,
    plugins = {
      bootstrapTooltip: $("[data-bs-toggle='tooltip']"),
      breadcrumbsCustom: $(".breadcrumbs-custom"),
      bootstrapTabs: $(".tabs-custom"),
      bootstrapAccordion: $(".accordion-custom-item"),
      customToggle: $("[data-custom-toggle]"),
      captcha: $(".recaptcha"),
      campaignMonitor: $(".campaign-mailform"),
      isotope: $(".isotope-wrap"),
      lightGallery: $("[data-lightgallery='group']"),
      lightGalleryItem: $("[data-lightgallery='item']"),
      lightDynamicGalleryItem: $("[data-lightgallery='dynamic']"),
      materialParallax: $(".parallax-container:not(.inited)"),
      mailchimp: $(".mailchimp-mailform"),
      popover: $('[data-bs-toggle="popover"]'),
      preloader: $(".preloader"),
      rdNavbar: $(".rd-navbar"),
      rdMailForm: $(".rd-mailform"),
      rdInputLabel: $(".form-label"),
      regula: $("[data-constraints]"),
      radio: $("input[type='radio']"),
      swiper: $(".swiper-container"),
      search: $(".rd-search"),
      slick: $(".slick-slider:not(.slick-initialized)"),
      slickMain: $(".slick-slider-main"),
      searchResults: $(".rd-search-results"),
      viewAnimate: $(".view-animate"),
      wow: $(".wow"),
      maps: $(".google-map-container"),
      counter: document.querySelectorAll(".counter"),
      progressLinear: document.querySelectorAll(".progress-linear"),
      progressCircle: document.querySelectorAll(".progress-circle"),
    };

  /**
   * @desc Check the element was been scrolled into the view
   * @param {object} elem - jQuery object
   * @return {boolean}
   */
  function isScrolledIntoView(elem) {
    if (isNoviBuilder) return true;
    return (
      elem.offset().top + elem.outerHeight() >= $window.scrollTop() &&
      elem.offset().top <= $window.scrollTop() + $window.height()
    );
  }

  /**
   * @desc Calls a function when element has been scrolled into the view
   * @param {object} element - jQuery object
   * @param {function} func - init function
   */
  function lazyInit(element, func) {
    var scrollHandler = function () {
      if (!element.hasClass("lazy-loaded") && isScrolledIntoView(element)) {
        func.call();
        element.addClass("lazy-loaded");
      }
    };

    scrollHandler();
    $window.on("scroll", scrollHandler);
  }

  // Initialize scripts that require a loaded page
  // $window.on("load", function () {
  // Page loader & Page transition
  // if (plugins.preloader.length && !isNoviBuilder) {
  // 	pageTransition({
  // 		target: document.querySelector('.page'),
  // 		delay: 0,
  // 		duration: 500,
  // 		classIn: 'fadeIn',
  // 		classOut: 'fadeOut',
  // 		classActive: 'animated',
  // 		conditions: function (event, link) {
  // 			return !/(\#|callto:|tel:|mailto:|:\/\/)/.test(link) && !event.currentTarget.hasAttribute('data-lightgallery');
  // 		},
  // 		onTransitionStart: function (options) {
  // 			// setTimeout(function () {
  // 			// 	plugins.preloader.removeClass('loaded');
  // 			// }, options.duration * .75);
  // 		},
  // 		onReady: function () {
  // 			// plugins.preloader.addClass('loaded');
  // 			windowReady = true;
  // 		}
  // 	});
  // }

  // Counter
  if (plugins.counter) {
    for (let i = 0; i < plugins.counter.length; i++) {
      let node = plugins.counter[i],
        counter = aCounter({
          node: node,
          duration: node.getAttribute("data-duration") || 1000,
        }),
        scrollHandler = function () {
          if (
            Util.inViewport(this) &&
            !this.classList.contains("animated-first")
          ) {
            this.counter.run();
            this.classList.add("animated-first");
          }
        }.bind(node),
        blurHandler = function () {
          this.counter.params.to = parseInt(this.textContent, 10);
          this.counter.run();
        }.bind(node);

      if (isNoviBuilder) {
        node.counter.run();
        node.addEventListener("blur", blurHandler);
      } else {
        scrollHandler();
        window.addEventListener("scroll", scrollHandler);
      }
    }
  }

  // Progress bar
  if (plugins.progressLinear) {
    for (let i = 0; i < plugins.progressLinear.length; i++) {
      let container = plugins.progressLinear[i],
        counter = aCounter({
          node: container.querySelector(".progress-linear-counter"),
          duration: container.getAttribute("data-duration") || 1000,
          onStart: function () {
            this.custom.bar.style.width = this.params.to + "%";
          },
        });

      counter.custom = {
        container: container,
        bar: container.querySelector(".progress-linear-bar"),
        onScroll: function () {
          if (
            (Util.inViewport(this.custom.container) &&
              !this.custom.container.classList.contains("animated")) ||
            isNoviBuilder
          ) {
            this.run();
            this.custom.container.classList.add("animated");
          }
        }.bind(counter),
        onBlur: function () {
          this.params.to = parseInt(this.params.node.textContent, 10);
          this.run();
        }.bind(counter),
      };

      if (isNoviBuilder) {
        counter.run();
        counter.params.node.addEventListener("blur", counter.custom.onBlur);
      } else {
        counter.custom.onScroll();
        document.addEventListener("scroll", counter.custom.onScroll);
      }
    }
  }

  // Progress Circle
  if (plugins.progressCircle) {
    for (let i = 0; i < plugins.progressCircle.length; i++) {
      let container = plugins.progressCircle[i],
        counter = aCounter({
          node: container.querySelector(".progress-circle-counter"),
          duration: 500,
          onUpdate: function (value) {
            this.custom.bar.render(value * 3.6);
          },
        });

      counter.params.onComplete = counter.params.onUpdate;

      counter.custom = {
        container: container,
        bar: aProgressCircle({
          node: container.querySelector(".progress-circle-bar"),
        }),
        onScroll: function () {
          if (
            Util.inViewport(this.custom.container) &&
            !this.custom.container.classList.contains("animated")
          ) {
            this.run();
            this.custom.container.classList.add("animated");
          }
        }.bind(counter),
        onBlur: function () {
          this.params.to = parseInt(this.params.node.textContent, 10);
          this.run();
        }.bind(counter),
      };

      if (isNoviBuilder) {
        counter.run();
        counter.params.node.addEventListener("blur", counter.custom.onBlur);
      } else {
        counter.custom.onScroll();
        window.addEventListener("scroll", counter.custom.onScroll);
      }
    }
  }

  // Isotope
  if (plugins.isotope.length) {
    for (var i = 0; i < plugins.isotope.length; i++) {
      var wrap = plugins.isotope[i],
        filterHandler = function (event) {
          event.preventDefault();
          for (var n = 0; n < this.isoGroup.filters.length; n++)
            this.isoGroup.filters[n].classList.remove("active");
          this.classList.add("active");
          this.isoGroup.isotope.arrange({
            filter:
              this.getAttribute("data-isotope-filter") !== "*"
                ? '[data-filter*="' +
                  this.getAttribute("data-isotope-filter") +
                  '"]'
                : "*",
          });
        },
        resizeHandler = function () {
          this.isoGroup.isotope.layout();
        };

      wrap.isoGroup = {};
      wrap.isoGroup.filters = wrap.querySelectorAll("[data-isotope-filter]");
      wrap.isoGroup.node = wrap.querySelector(".isotope");
      wrap.isoGroup.layout = wrap.isoGroup.node.getAttribute(
        "data-isotope-layout"
      )
        ? wrap.isoGroup.node.getAttribute("data-isotope-layout")
        : "masonry";
      wrap.isoGroup.isotope = new Isotope(wrap.isoGroup.node, {
        itemSelector: ".isotope-item",
        layoutMode: wrap.isoGroup.layout,
        filter: "*",
      });

      for (var n = 0; n < wrap.isoGroup.filters.length; n++) {
        var filter = wrap.isoGroup.filters[n];
        filter.isoGroup = wrap.isoGroup;
        filter.addEventListener("click", filterHandler);
      }

      window.addEventListener("resize", resizeHandler.bind(wrap));
    }
  }

  // Material Parallax
  if (plugins.materialParallax.length) {
    if (!isNoviBuilder && !isIE && !isMobile) {
      plugins.materialParallax.parallax();
    } else {
      for (var i = 0; i < plugins.materialParallax.length; i++) {
        var $parallax = $(plugins.materialParallax[i]);

        $parallax.addClass("parallax-disabled");
        $parallax.css({
          "background-image": "url(" + $parallax.data("parallax-img") + ")",
        });
      }
    }
  }
  // });

  // Initialize scripts that require a finished document
  $(function () {
    isNoviBuilder = window.xMode;

    /**
     * Wrapper to eliminate json errors
     * @param {string} str - JSON string
     * @returns {object} - parsed or empty object
     */
    function parseJSON(str) {
      try {
        if (str) return JSON.parse(str);
        else return {};
      } catch (error) {
        console.warn(error);
        return {};
      }
    }

    /**
     * @desc Sets the actual previous index based on the position of the slide in the markup. Should be the most recent action.
     * @param {object} swiper - swiper instance
     */
    function setRealPrevious(swiper) {
      let element = swiper.$wrapperEl[0].children[swiper.activeIndex];
      swiper.realPrevious = Array.prototype.indexOf.call(
        element.parentNode.children,
        element
      );
    }

    /**
     * @desc Sets slides background images from attribute 'data-slide-bg'
     * @param {object} swiper - swiper instance
     */
    function setBackgrounds(swiper) {
      let swipersBg = swiper.el.querySelectorAll("[data-slide-bg]");

      for (let i = 0; i < swipersBg.length; i++) {
        let swiperBg = swipersBg[i];
        swiperBg.style.backgroundImage =
          "url(" + swiperBg.getAttribute("data-slide-bg") + ")";
      }
    }

    /**
     * @desc Attach form validation to elements
     * @param {object} elements - jQuery object
     */
    function attachFormValidator(elements) {
      // Custom validator - phone number
      regula.custom({
        name: "PhoneNumber",
        defaultMessage: "Invalid phone number format",
        validator: function () {
          if (this.value === "") return true;
          else return /^(\+\d)?[0-9\-\(\) ]{5,}$/i.test(this.value);
        },
      });

      for (var i = 0; i < elements.length; i++) {
        var o = $(elements[i]),
          v;
        o.addClass("form-control-has-validation").after(
          "<span class='form-validation'></span>"
        );
        v = o.parent().find(".form-validation");
        if (v.is(":last-child")) o.addClass("form-control-last-child");
      }

      elements
        .on("input change propertychange blur", function (e) {
          var $this = $(this),
            results;

          if (e.type !== "blur")
            if (!$this.parent().hasClass("has-error")) return;
          if ($this.parents(".rd-mailform").hasClass("success")) return;

          if ((results = $this.regula("validate")).length) {
            for (i = 0; i < results.length; i++) {
              $this
                .siblings(".form-validation")
                .text(results[i].message)
                .parent()
                .addClass("has-error");
            }
          } else {
            $this
              .siblings(".form-validation")
              .text("")
              .parent()
              .removeClass("has-error");
          }
        })
        .regula("bind");

      var regularConstraintsMessages = [
        {
          type: regula.Constraint.Required,
          newMessage: "The text field is required.",
        },
        {
          type: regula.Constraint.Email,
          newMessage: "The email is not a valid email.",
        },
        {
          type: regula.Constraint.Numeric,
          newMessage: "Only numbers are required",
        },
        {
          type: regula.Constraint.Selected,
          newMessage: "Please choose an option.",
        },
      ];

      for (var i = 0; i < regularConstraintsMessages.length; i++) {
        var regularConstraint = regularConstraintsMessages[i];

        regula.override({
          constraintType: regularConstraint.type,
          defaultMessage: regularConstraint.newMessage,
        });
      }
    }

    /**
     * @desc Check if all elements pass validation
     * @param {object} elements - object of items for validation
     * @param {object} captcha - captcha object for validation
     * @return {boolean}
     */
    function isValidated(elements, captcha) {
      var results,
        errors = 0;

      if (elements.length) {
        for (var j = 0; j < elements.length; j++) {
          var $input = $(elements[j]);
          if ((results = $input.regula("validate")).length) {
            for (k = 0; k < results.length; k++) {
              errors++;
              $input
                .siblings(".form-validation")
                .text(results[k].message)
                .parent()
                .addClass("has-error");
            }
          } else {
            $input
              .siblings(".form-validation")
              .text("")
              .parent()
              .removeClass("has-error");
          }
        }

        if (captcha) {
          if (captcha.length) {
            return validateReCaptcha(captcha) && errors === 0;
          }
        }

        return errors === 0;
      }
      return true;
    }

    /**
     * @desc Validate google reCaptcha
     * @param {object} captcha - captcha object for validation
     * @return {boolean}
     */
    function validateReCaptcha(captcha) {
      var captchaToken = captcha.find(".g-recaptcha-response").val();

      if (captchaToken.length === 0) {
        captcha
          .siblings(".form-validation")
          .html("Please, prove that you are not robot.")
          .addClass("active");
        captcha.closest(".form-wrap").addClass("has-error");

        captcha.on("propertychange", function () {
          var $this = $(this),
            captchaToken = $this.find(".g-recaptcha-response").val();

          if (captchaToken.length > 0) {
            $this.closest(".form-wrap").removeClass("has-error");
            $this.siblings(".form-validation").removeClass("active").html("");
            $this.off("propertychange");
          }
        });

        return false;
      }

      return true;
    }

    /**
     * @desc Initialize Google reCaptcha
     */
    window.onloadCaptchaCallback = function () {
      for (var i = 0; i < plugins.captcha.length; i++) {
        var $capthcaItem = $(plugins.captcha[i]);

        grecaptcha.render($capthcaItem.attr("id"), {
          sitekey: $capthcaItem.attr("data-sitekey"),
          size: $capthcaItem.attr("data-size")
            ? $capthcaItem.attr("data-size")
            : "normal",
          theme: $capthcaItem.attr("data-theme")
            ? $capthcaItem.attr("data-theme")
            : "light",
          callback: function (e) {
            $(".recaptcha").trigger("propertychange");
          },
        });
        $capthcaItem.after("<span class='form-validation'></span>");
      }
    };

    /**
     * @desc Initialize Bootstrap tooltip with required placement
     * @param {string} tooltipPlacement
     */
    function initBootstrapTooltip(tooltipPlacement) {
      plugins.bootstrapTooltip.tooltip("dispose");

      if (window.innerWidth < 576) {
        plugins.bootstrapTooltip.tooltip({ placement: "bottom" });
      } else {
        plugins.bootstrapTooltip.tooltip({ placement: tooltipPlacement });
      }
    }

    /**
     * @desc Initialize the gallery with set of images
     * @param {object} itemsToInit - jQuery object
     * @param {string} addClass - additional gallery class
     */
    function initLightGallery(itemsToInit, addClass) {
      if (!isNoviBuilder) {
        $(itemsToInit).lightGallery({
          thumbnail: $(itemsToInit).attr("data-lg-thumbnail") !== "false",
          selector: "[data-lightgallery='item']",
          zoom: $(itemsToInit).attr("data-zoom") === "true",
          autoplay: $(itemsToInit).attr("data-lg-autoplay") === "true",
          pause:
            parseInt($(itemsToInit).attr("data-lg-autoplay-delay")) || 5000,
          addClass: addClass,
          mode: $(itemsToInit).attr("data-lg-animation") || "lg-slide",
          loop: $(itemsToInit).attr("data-lg-loop") !== "false",
        });
      }
    }

    /**
     * @desc Initialize the gallery with dynamic addition of images
     * @param {object} itemsToInit - jQuery object
     * @param {string} addClass - additional gallery class
     */
    function initDynamicLightGallery(itemsToInit, addClass) {
      if (!isNoviBuilder) {
        $(itemsToInit).on("click", function () {
          $(itemsToInit).lightGallery({
            thumbnail: $(itemsToInit).attr("data-lg-thumbnail") !== "false",
            selector: "[data-lightgallery='item']",
            autoplay: $(itemsToInit).attr("data-lg-autoplay") === "true",
            pause:
              parseInt($(itemsToInit).attr("data-lg-autoplay-delay")) || 5000,
            addClass: addClass,
            mode: $(itemsToInit).attr("data-lg-animation") || "lg-slide",
            loop: $(itemsToInit).attr("data-lg-loop") !== "false",
            dynamic: true,
            dynamicEl:
              JSON.parse($(itemsToInit).attr("data-lg-dynamic-elements")) || [],
          });
        });
      }
    }

    /**
     * @desc Initialize the gallery with one image
     * @param {object} itemToInit - jQuery object
     * @param {string} addClass - additional gallery class
     */
    function initLightGalleryItem(itemToInit, addClass) {
      if (!isNoviBuilder) {
        $(itemToInit).lightGallery({
          selector: "this",
          addClass: addClass,
          counter: false,
          youtubePlayerParams: {
            modestbranding: 1,
            showinfo: 0,
            rel: 0,
            controls: 0,
          },
          vimeoPlayerParams: {
            byline: 0,
            portrait: 0,
          },
        });
      }
    }

    /**
     * @desc Google map function for getting latitude and longitude
     */
    function getLatLngObject(str, marker, map, callback) {
      var coordinates = {};
      try {
        coordinates = JSON.parse(str);
        callback(
          new google.maps.LatLng(coordinates.lat, coordinates.lng),
          marker,
          map
        );
      } catch (e) {
        map.geocoder.geocode({ address: str }, function (results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            var latitude = results[0].geometry.location.lat();
            var longitude = results[0].geometry.location.lng();

            callback(
              new google.maps.LatLng(
                parseFloat(latitude),
                parseFloat(longitude)
              ),
              marker,
              map
            );
          }
        });
      }
    }

    /**
     * @desc Initialize Google maps
     */
    function initMaps() {
      var key;

      for (var i = 0; i < plugins.maps.length; i++) {
        if (plugins.maps[i].hasAttribute("data-key")) {
          key = plugins.maps[i].getAttribute("data-key");
          break;
        }
      }

      $.getScript(
        "//maps.google.com/maps/api/js?" +
          (key ? "key=" + key + "&" : "") +
          "sensor=false&libraries=geometry,places&v=quarterly",
        function () {
          var head = document.getElementsByTagName("head")[0],
            insertBefore = head.insertBefore;

          head.insertBefore = function (newElement, referenceElement) {
            if (
              (newElement.href &&
                newElement.href.indexOf(
                  "//fonts.googleapis.com/css?family=Roboto"
                ) !== -1) ||
              newElement.innerHTML.indexOf("gm-style") !== -1
            ) {
              return;
            }
            insertBefore.call(head, newElement, referenceElement);
          };
          var geocoder = new google.maps.Geocoder();
          for (var i = 0; i < plugins.maps.length; i++) {
            var zoom =
              parseInt(plugins.maps[i].getAttribute("data-zoom"), 10) || 11;
            var styles = plugins.maps[i].hasAttribute("data-styles")
              ? JSON.parse(plugins.maps[i].getAttribute("data-styles"))
              : [];
            var center =
              plugins.maps[i].getAttribute("data-center") || "New York";

            // Initialize map
            var map = new google.maps.Map(
              plugins.maps[i].querySelectorAll(".google-map")[0],
              {
                zoom: zoom,
                styles: styles,
                scrollwheel: false,
                center: { lat: 0, lng: 0 },
              }
            );

            // Add map object to map node
            plugins.maps[i].map = map;
            plugins.maps[i].geocoder = geocoder;
            plugins.maps[i].google = google;

            // Get Center coordinates from attribute
            getLatLngObject(
              center,
              null,
              plugins.maps[i],
              function (location, markerElement, mapElement) {
                mapElement.map.setCenter(location);
              }
            );

            // Add markers from google-map-markers array
            var markerItems = plugins.maps[i].querySelectorAll(
              ".google-map-markers li"
            );

            if (markerItems.length) {
              var markers = [];
              for (var j = 0; j < markerItems.length; j++) {
                var markerElement = markerItems[j];
                getLatLngObject(
                  markerElement.getAttribute("data-location"),
                  markerElement,
                  plugins.maps[i],
                  function (location, markerElement, mapElement) {
                    var icon =
                      markerElement.getAttribute("data-icon") ||
                      mapElement.getAttribute("data-icon");
                    var activeIcon =
                      markerElement.getAttribute("data-icon-active") ||
                      mapElement.getAttribute("data-icon-active");
                    var info =
                      markerElement.getAttribute("data-description") || "";
                    var infoWindow = new google.maps.InfoWindow({
                      content: info,
                    });
                    markerElement.infoWindow = infoWindow;
                    var markerData = {
                      position: location,
                      map: mapElement.map,
                    };
                    if (icon) {
                      markerData.icon = icon;
                    }
                    var marker = new google.maps.Marker(markerData);
                    markerElement.gmarker = marker;
                    markers.push({
                      markerElement: markerElement,
                      infoWindow: infoWindow,
                    });
                    marker.isActive = false;
                    // Handle infoWindow close click
                    google.maps.event.addListener(
                      infoWindow,
                      "closeclick",
                      function (markerElement, mapElement) {
                        var markerIcon = null;
                        markerElement.gmarker.isActive = false;
                        markerIcon =
                          markerElement.getAttribute("data-icon") ||
                          mapElement.getAttribute("data-icon");
                        markerElement.gmarker.setIcon(markerIcon);
                      }.bind(this, markerElement, mapElement)
                    );

                    // Set marker active on Click and open infoWindow
                    google.maps.event.addListener(
                      marker,
                      "click",
                      function (markerElement, mapElement) {
                        if (markerElement.infoWindow.getContent().length === 0)
                          return;
                        var gMarker,
                          currentMarker = markerElement.gmarker,
                          currentInfoWindow;
                        for (var k = 0; k < markers.length; k++) {
                          var markerIcon;
                          if (markers[k].markerElement === markerElement) {
                            currentInfoWindow = markers[k].infoWindow;
                          }
                          gMarker = markers[k].markerElement.gmarker;
                          if (
                            gMarker.isActive &&
                            markers[k].markerElement !== markerElement
                          ) {
                            gMarker.isActive = false;
                            markerIcon =
                              markers[k].markerElement.getAttribute(
                                "data-icon"
                              ) || mapElement.getAttribute("data-icon");
                            gMarker.setIcon(markerIcon);
                            markers[k].infoWindow.close();
                          }
                        }

                        currentMarker.isActive = !currentMarker.isActive;
                        if (currentMarker.isActive) {
                          if (
                            (markerIcon =
                              markerElement.getAttribute("data-icon-active") ||
                              mapElement.getAttribute("data-icon-active"))
                          ) {
                            currentMarker.setIcon(markerIcon);
                          }

                          currentInfoWindow.open(map, marker);
                        } else {
                          if (
                            (markerIcon =
                              markerElement.getAttribute("data-icon") ||
                              mapElement.getAttribute("data-icon"))
                          ) {
                            currentMarker.setIcon(markerIcon);
                          }
                          currentInfoWindow.close();
                        }
                      }.bind(this, markerElement, mapElement)
                    );
                  }
                );
              }
            }
          }
        }
      );
    }

    // Google ReCaptcha
    if (plugins.captcha.length) {
      $.getScript(
        "//www.google.com/recaptcha/api.js?onload=onloadCaptchaCallback&render=explicit&hl=en"
      );
    }

    // Additional class on html if mac os.
    if (navigator.platform.match(/(Mac)/i)) {
      $html.addClass("mac-os");
    }

    // Adds some loosing functionality to IE browsers (IE Polyfills)
    if (isIE) {
      if (isIE === 12) $html.addClass("ie-edge");
      if (isIE === 11) $html.addClass("ie-11");
      if (isIE < 10) $html.addClass("lt-ie-10");
      if (isIE < 11) $html.addClass("ie-10");
    }

    // Bootstrap Tooltips
    if (plugins.bootstrapTooltip.length) {
      var tooltipPlacement = plugins.bootstrapTooltip.attr("data-bs-placement");
      initBootstrapTooltip(tooltipPlacement);

      $window.on("resize orientationchange", function () {
        initBootstrapTooltip(tooltipPlacement);
      });
    }

    // Popovers
    if (plugins.popover.length) {
      if (window.innerWidth < 767) {
        plugins.popover.attr("data-bs-placement", "bottom");
        plugins.popover.popover();
      } else {
        plugins.popover.popover();
      }
    }

    // Bootstrap tabs
    // if (plugins.bootstrapTabs.length) {
    //   for (var i = 0; i < plugins.bootstrapTabs.length; i++) {
    //     var bootstrapTabsItem = $(plugins.bootstrapTabs[i]);
    //     var customBgBreadcrumbs = bootstrapTabsItem.find(
    //       $("[data-breadcrumbs-bg]")
    //     );

    //     if (customBgBreadcrumbs && plugins.breadcrumbsCustom) {
    //       customBgBreadcrumbs.on("click", function () {
    //         if (!$(this).hasClass("active")) {
    //           var imagePath = $(this).attr("data-breadcrumbs-bg");
    //           plugins.breadcrumbsCustom.addClass("active");
    //           plugins.breadcrumbsCustom.css({
    //             "background-image": "url(" + imagePath + ")",
    //           });
    //           setTimeout(function () {
    //             plugins.breadcrumbsCustom.removeClass("active");
    //           }, 250);
    //         }
    //       });
    //     }
    //   }
    // }

    // Google maps
    if (plugins.maps.length) {
      lazyInit(plugins.maps, initMaps);
    }

    // Add custom styling options for input[type="radio"]
    if (plugins.radio.length) {
      for (var i = 0; i < plugins.radio.length; i++) {
        $(plugins.radio[i])
          .addClass("radio-custom")
          .after("<span class='radio-custom-dummy'></span>");
      }
    }

    // UI To Top
    if (isDesktop && !isNoviBuilder) {
      const initFunc = $();
      if (!initFunc.isUItoTopInited) {
        initFunc.UItoTop({
          easingType: "easeOutQuad",
          containerClass: "ui-to-top fa fa-angle-up",
          scrollSpeed: 100,
        });
      }
    }

    // RD Navbar
    if (plugins.rdNavbar.length) {
      var aliaces, i, j, len, value, values, responsiveNavbar;

      aliaces = ["-", "-sm-", "-md-", "-lg-", "-xl-", "-xxl-"];
      values = [0, 576, 768, 992, 1200, 1600];
      responsiveNavbar = {};

      for (i = j = 0, len = values.length; j < len; i = ++j) {
        value = values[i];
        if (!responsiveNavbar[values[i]]) {
          responsiveNavbar[values[i]] = {};
        }
        if (plugins.rdNavbar.attr("data" + aliaces[i] + "layout")) {
          responsiveNavbar[values[i]].layout = plugins.rdNavbar.attr(
            "data" + aliaces[i] + "layout"
          );
        }
        if (plugins.rdNavbar.attr("data" + aliaces[i] + "device-layout")) {
          responsiveNavbar[values[i]]["deviceLayout"] = plugins.rdNavbar.attr(
            "data" + aliaces[i] + "device-layout"
          );
        }
        if (plugins.rdNavbar.attr("data" + aliaces[i] + "hover-on")) {
          responsiveNavbar[values[i]]["focusOnHover"] =
            plugins.rdNavbar.attr("data" + aliaces[i] + "hover-on") === "true";
        }
        if (plugins.rdNavbar.attr("data" + aliaces[i] + "auto-height")) {
          responsiveNavbar[values[i]]["autoHeight"] =
            plugins.rdNavbar.attr("data" + aliaces[i] + "auto-height") ===
            "true";
        }

        if (isNoviBuilder) {
          responsiveNavbar[values[i]]["stickUp"] = false;
        } else if (plugins.rdNavbar.attr("data" + aliaces[i] + "stick-up")) {
          responsiveNavbar[values[i]]["stickUp"] =
            plugins.rdNavbar.attr("data" + aliaces[i] + "stick-up") === "true";
        }

        if (plugins.rdNavbar.attr("data" + aliaces[i] + "stick-up-offset")) {
          responsiveNavbar[values[i]]["stickUpOffset"] = plugins.rdNavbar.attr(
            "data" + aliaces[i] + "stick-up-offset"
          );
        }
      }

      plugins.rdNavbar.RDNavbar({
        anchorNav: !isNoviBuilder,
        stickUpClone:
          plugins.rdNavbar.attr("data-stick-up-clone") && !isNoviBuilder
            ? plugins.rdNavbar.attr("data-stick-up-clone") === "true"
            : false,
        responsive: responsiveNavbar,
        callbacks: {
          onStuck: function () {
            var navbarSearch = this.$element.find(".rd-search input");

            if (navbarSearch) {
              navbarSearch.val("").trigger("propertychange");
            }
          },
          onDropdownOver: function () {
            return !isNoviBuilder;
          },
          onUnstuck: function () {
            if (this.$clone === null) return;

            var navbarSearch = this.$clone.find(".rd-search input");

            if (navbarSearch) {
              navbarSearch.val("").trigger("propertychange");
              navbarSearch.trigger("blur");
            }
          },
        },
      });

      if (plugins.rdNavbar.attr("data-body-class")) {
        document.body.className +=
          " " + plugins.rdNavbar.attr("data-body-class");
      }
    }

    // Add class in viewport
    if (plugins.viewAnimate.length) {
      for (var i = 0; i < plugins.viewAnimate.length; i++) {
        var $view = $(plugins.viewAnimate[i]).not(".active");
        $document
          .on(
            "scroll",
            $.proxy(function () {
              if (isScrolledIntoView(this)) {
                this.addClass("active");
              }
            }, $view)
          )
          .trigger("scroll");
      }
    }

    // Swiper
    if (plugins.swiper.length) {
      for (let i = 0; i < plugins.swiper.length; i++) {
        let node = plugins.swiper[i],
          params = parseJSON(node.getAttribute("data-swiper")),
          defaults = {
            speed: 1000,
            loop: true,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            autoplay: {
              delay: 5000,
            },
          },
          xMode = {
            autoplay: false,
            loop: false,
            simulateTouch: false,
          };

        params.on = {
          init: function () {
            setBackgrounds(this);
            setRealPrevious(this);
            initCaptionAnimate(this);

            // Real Previous Index must be set recent
            this.on("slideChangeTransitionEnd", function () {
              setRealPrevious(this);
            });
          },
        };

        new Swiper(
          node,
          Util.merge(
            isNoviBuilder ? [defaults, params, xMode] : [defaults, params]
          )
        );
      }
    }

    function leadingZero(decimal) {
      return decimal < 10 && decimal > 0 ? decimal : decimal;
    }

    /**
     * Slick carousel
     * @description  Enable Slick carousel plugin
     */

    if (plugins.slick.length) {
      for (var i = 0; i < plugins.slick.length; i++) {
        var $slickItem = $(plugins.slick[i]);

        $slickItem.on("init", function (slick) {
          initLightGallery(
            $('[data-lightgallery="group-slick"]'),
            "lightGallery-in-carousel"
          );
          initLightGallery(
            $('[data-lightgallery="item-slick"]'),
            "lightGallery-in-carousel"
          );
        });

        $slickItem
          .slick({
            slidesToScroll:
              parseInt($slickItem.attr("data-slide-to-scroll"), 10) || 1,
            asNavFor: $slickItem.attr("data-for") || false,
            dots: $slickItem.attr("data-dots") === "true",
            infinite: isNoviBuilder
              ? false
              : $slickItem.attr("data-loop") === "true",
            focusOnSelect: $slickItem.attr("data-select") === "true",
            draggable: isNoviBuilder
              ? false
              : $slickItem.attr("data-draggable") === "true",
            arrows: $slickItem.attr("data-arrows") === "true",
            fade: $slickItem.attr("data-fade") === "true",
            appendArrows: $slickItem.attr("data-arrows-class") || $slickItem,
            nextArrow:
              $slickItem.attr("data-custom-arrows") === "true"
                ? '<button type="button" class="slick-next">' + "</button>"
                : '<button type="button" class="slick-next"></button>',
            prevArrow:
              $slickItem.attr("data-custom-arrows") === "true"
                ? '<button type="button" class="slick-prev">' + "</button>"
                : '<button type="button" class="slick-prev"></button>',
            swipe: $slickItem.attr("data-swipe") === "true",
            autoplay: $slickItem.attr("data-autoplay") === "true",
            vertical: $slickItem.attr("data-vertical") === "true",
            centerMode: $slickItem.attr("data-center-mode") === "true",
            centerPadding: $slickItem.attr("data-center-padding")
              ? $slickItem.attr("data-center-padding")
              : "0.50",
            mobileFirst: true,
            responsive: [
              {
                breakpoint: 0,
                settings: {
                  slidesToShow:
                    parseInt($slickItem.attr("data-items"), 10) || 1,
                },
              },
              {
                breakpoint: 575,
                settings: {
                  slidesToShow:
                    parseInt($slickItem.attr("data-sm-items"), 10) || 1,
                },
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow:
                    parseInt($slickItem.attr("data-md-items"), 10) || 1,
                },
              },
              {
                breakpoint: 991,
                settings: {
                  slidesToShow:
                    parseInt($slickItem.attr("data-lg-items"), 10) || 1,
                },
              },
              {
                breakpoint: 1199,
                settings: {
                  slidesToShow:
                    parseInt($slickItem.attr("data-xl-items"), 10) || 1,
                },
              },
            ],
          })
          .on("afterChange", function (event, slick, currentSlide, nextSlide) {
            var $this = $(this),
              childCarousel = $this.attr("data-child");

            if (childCarousel) {
              $(childCarousel + " .slick-slide").removeClass("slick-current");
              $(childCarousel + " .slick-slide")
                .eq(currentSlide)
                .addClass("slick-current");
            }
          });

        // Indexing Slick Slider
        if ($slickItem.attr("data-fraction")) {
          (function () {
            var fractionElement = document.querySelectorAll(
                $slickItem.attr("data-fraction")
              )[0],
              fractionCurrent = fractionElement.querySelectorAll(
                ".slick-fraction-current"
              )[0],
              fractionAll = fractionElement.querySelectorAll(
                ".slick-fraction-all"
              )[0];

            $slickItem.on("afterChange", function (slick) {
              fractionCurrent.innerText = leadingZero(
                this.slick.currentSlide + 1
              );
              fractionAll.innerText = leadingZero(this.slick.slideCount);

              $(".custom-slick-arrows .slick-arrow").click(function () {
                slickSliderMain.find($(".slick-slider")).slick("slickGoTo", 0);
              });
            });

            $slickItem.trigger("afterChange");
          })();
        }
      }

      // Filtering Slick Slider
      if (plugins.slick.attr("data-filter")) {
        var link = $(plugins.slick.attr("data-filter")).find("a");
        var slickSliderMain = $(
          $(plugins.slick.attr("data-filter")).attr("data-filter-parent")
        );

        link.on("click", function (event) {
          var filter = $(this).attr("data-value");

          event.preventDefault();
          link.removeClass("active");
          $(this).addClass("active");

          slickSliderMain.css({
            opacity: 0,
          });

          setTimeout(function () {
            slickSliderMain.slick("slickUnfilter");
            slickSliderMain.slick("slickFilter", filter);
            slickSliderMain.slick("slickGoTo", 0);
            slickSliderMain.find(plugins.slick).slick("slickGoTo", 0);

            slickSliderMain.css({
              opacity: 1,
            });

            slickSliderMain.trigger("aftereChange");
          }, 200);
        });
      }
    }

    // WOW
    if (
      $html.hasClass("wow-animation") &&
      plugins.wow.length &&
      !isNoviBuilder &&
      isDesktop &&
      !isMobile
    ) {
      new WOW().init();
    }

    // Bootstrap Accordion
    if (plugins.bootstrapAccordion.length) {
      for (let i = 0; i < plugins.bootstrapAccordion.length; i++) {
        let accordionItem = plugins.bootstrapAccordion[i];
        let accordionHead = accordionItem.querySelector(
          ".accordion-custom-button"
        );

        if (accordionHead.getAttribute("aria-expanded") !== "true") {
          accordionHead.classList.add("collapsed");
          accordionHead.setAttribute("aria-expanded", "false");
        }
      }
    }

    // RD Input Label
    if (plugins.rdInputLabel.length) {
      plugins.rdInputLabel.RDInputLabel();
    }

    // Regula
    if (plugins.regula.length) {
      attachFormValidator(plugins.regula);
    }

    // MailChimp Ajax subscription
    if (plugins.mailchimp.length) {
      for (i = 0; i < plugins.mailchimp.length; i++) {
        var $mailchimpItem = $(plugins.mailchimp[i]),
          $email = $mailchimpItem.find('input[type="email"]');

        // Required by MailChimp
        $mailchimpItem.attr("novalidate", "true");
        $email.attr("name", "EMAIL");

        $mailchimpItem.on(
          "submit",
          $.proxy(
            function ($email, event) {
              event.preventDefault();

              var $this = this;

              var data = {},
                url = $this
                  .attr("action")
                  .replace("/post?", "/post-json?")
                  .concat("&c=?"),
                dataArray = $this.serializeArray(),
                $output = $("#" + $this.attr("data-form-output"));

              for (i = 0; i < dataArray.length; i++) {
                data[dataArray[i].name] = dataArray[i].value;
              }

              $.ajax({
                data: data,
                url: url,
                dataType: "jsonp",
                error: function (resp, text) {
                  $output.html("Server error: " + text);

                  setTimeout(function () {
                    $output.removeClass("active");
                  }, 4000);
                },
                success: function (resp) {
                  $output.html(resp.msg).addClass("active");
                  $email[0].value = "";
                  var $label = $('[for="' + $email.attr("id") + '"]');
                  if ($label.length) $label.removeClass("focus not-empty");

                  setTimeout(function () {
                    $output.removeClass("active");
                  }, 6000);
                },
                beforeSend: function (data) {
                  var isNoviBuilder = window.xMode;

                  var isValidated = (function () {
                    var results,
                      errors = 0;
                    var elements = $this.find("[data-constraints]");
                    var captcha = null;
                    if (elements.length) {
                      for (var j = 0; j < elements.length; j++) {
                        var $input = $(elements[j]);
                        if ((results = $input.regula("validate")).length) {
                          for (var k = 0; k < results.length; k++) {
                            errors++;
                            $input
                              .siblings(".form-validation")
                              .text(results[k].message)
                              .parent()
                              .addClass("has-error");
                          }
                        } else {
                          $input
                            .siblings(".form-validation")
                            .text("")
                            .parent()
                            .removeClass("has-error");
                        }
                      }

                      if (captcha) {
                        if (captcha.length) {
                          return validateReCaptcha(captcha) && errors === 0;
                        }
                      }

                      return errors === 0;
                    }
                    return true;
                  })();

                  // Stop request if builder or inputs are invalide
                  if (isNoviBuilder || !isValidated) return false;

                  $output.html("Submitting...").addClass("active");
                },
              });

              return false;
            },
            $mailchimpItem,
            $email
          )
        );
      }
    }

    // Campaign Monitor ajax subscription
    if (plugins.campaignMonitor.length) {
      for (i = 0; i < plugins.campaignMonitor.length; i++) {
        var $campaignItem = $(plugins.campaignMonitor[i]);

        $campaignItem.on(
          "submit",
          $.proxy(function (e) {
            var data = {},
              url = this.attr("action"),
              dataArray = this.serializeArray(),
              $output = $(
                "#" + plugins.campaignMonitor.attr("data-form-output")
              ),
              $this = $(this);

            for (i = 0; i < dataArray.length; i++) {
              data[dataArray[i].name] = dataArray[i].value;
            }

            $.ajax({
              data: data,
              url: url,
              dataType: "jsonp",
              error: function (resp, text) {
                $output.html("Server error: " + text);

                setTimeout(function () {
                  $output.removeClass("active");
                }, 4000);
              },
              success: function (resp) {
                $output.html(resp.Message).addClass("active");

                setTimeout(function () {
                  $output.removeClass("active");
                }, 6000);
              },
              beforeSend: function (data) {
                // Stop request if builder or inputs are invalide
                if (
                  isNoviBuilder ||
                  !isValidated($this.find("[data-constraints]"))
                )
                  return false;

                $output.html("Submitting...").addClass("active");
              },
            });

            // Clear inputs after submit
            var inputs = $this[0].getElementsByTagName("input");
            for (var i = 0; i < inputs.length; i++) {
              inputs[i].value = "";
              var label = document.querySelector(
                '[for="' + inputs[i].getAttribute("id") + '"]'
              );
              if (label) label.classList.remove("focus", "not-empty");
            }

            return false;
          }, $campaignItem)
        );
      }
    }

    // RD Mailform
    if (plugins.rdMailForm.length) {
      var i,
        j,
        k,
        msg = {
          MF000: "Successfully sent!",
          MF001: "Recipients are not set!",
          MF002: "Form will not work locally!",
          MF003: "Please, define email field in your form!",
          MF004: "Please, define type of your form!",
          MF254: "Something went wrong with PHPMailer!",
          MF255: "Aw, snap! Something went wrong.",
        };

      for (i = 0; i < plugins.rdMailForm.length; i++) {
        var $form = $(plugins.rdMailForm[i]),
          formHasCaptcha = false;

        $form.attr("novalidate", "novalidate").ajaxForm({
          data: {
            "form-type": $form.attr("data-form-type") || "contact",
            counter: i,
          },
          beforeSubmit: function (arr, $form, options) {
            if (isNoviBuilder) return;

            var form = $(plugins.rdMailForm[this.extraData.counter]),
              inputs = form.find("[data-constraints]"),
              output = $("#" + form.attr("data-form-output")),
              captcha = form.find(".recaptcha"),
              captchaFlag = true;

            output.removeClass("active error success");

            if (isValidated(inputs, captcha)) {
              // veify reCaptcha
              if (captcha.length) {
                var captchaToken = captcha.find(".g-recaptcha-response").val(),
                  captchaMsg = {
                    CPT001:
                      'Please, setup you "site key" and "secret key" of reCaptcha',
                    CPT002: "Something wrong with google reCaptcha",
                  };

                formHasCaptcha = true;

                $.ajax({
                  method: "POST",
                  url: "/bat/reCaptcha.php",
                  data: { "g-recaptcha-response": captchaToken },
                  async: false,
                }).done(function (responceCode) {
                  if (responceCode !== "CPT000") {
                    if (output.hasClass("snackbars")) {
                      output.html(
                        '<p><span class="icon text-middle mdi mdi-check icon-xxs"></span><span>' +
                          captchaMsg[responceCode] +
                          "</span></p>"
                      );

                      setTimeout(function () {
                        output.removeClass("active");
                      }, 3500);

                      captchaFlag = false;
                    } else {
                      output.html(captchaMsg[responceCode]);
                    }

                    output.addClass("active");
                  }
                });
              }

              if (!captchaFlag) {
                return false;
              }

              form.addClass("form-in-process");

              if (output.hasClass("snackbars")) {
                output.html(
                  '<p><span class="icon text-middle fa fa-circle-o-notch fa-spin icon-xxs"></span><span>Sending</span></p>'
                );
                output.addClass("active");
              }
            } else {
              return false;
            }
          },
          error: function (result) {
            if (isNoviBuilder) return;

            var output = $(
                "#" +
                  $(plugins.rdMailForm[this.extraData.counter]).attr(
                    "data-form-output"
                  )
              ),
              form = $(plugins.rdMailForm[this.extraData.counter]);

            output.text(msg[result]);
            form.removeClass("form-in-process");

            if (formHasCaptcha) {
              grecaptcha.reset();
            }
          },
          success: function (result) {
            if (isNoviBuilder) return;

            var form = $(plugins.rdMailForm[this.extraData.counter]),
              output = $("#" + form.attr("data-form-output")),
              select = form.find("select");

            form.addClass("success").removeClass("form-in-process");

            if (formHasCaptcha) {
              grecaptcha.reset();
            }

            result = result.length === 5 ? result : "MF255";
            output.text(msg[result]);

            if (result === "MF000") {
              if (output.hasClass("snackbars")) {
                output.html(
                  '<p><span class="icon text-middle mdi mdi-check icon-xxs"></span><span>' +
                    msg[result] +
                    "</span></p>"
                );
              } else {
                output.addClass("active success");
              }
            } else {
              if (output.hasClass("snackbars")) {
                output.html(
                  ' <p class="snackbars-left"><span class="icon icon-xxs mdi mdi-alert-outline text-middle"></span><span>' +
                    msg[result] +
                    "</span></p>"
                );
              } else {
                output.addClass("active error");
              }
            }

            form.clearForm();

            if (select.length) {
              select.select2("val", "");
            }

            form.find("input, textarea").trigger("blur");

            setTimeout(function () {
              output.removeClass("active error success");
              form.removeClass("success");
            }, 3500);
          },
        });
      }
    }

    // lightGallery
    if (plugins.lightGallery.length) {
      for (var i = 0; i < plugins.lightGallery.length; i++) {
        initLightGallery(plugins.lightGallery[i]);
      }
    }

    // lightGallery item
    if (plugins.lightGalleryItem.length) {
      // Filter carousel items
      var notCarouselItems = [];

      for (var z = 0; z < plugins.lightGalleryItem.length; z++) {
        if (
          !$(plugins.lightGalleryItem[z]).parents(".owl-carousel").length &&
          !$(plugins.lightGalleryItem[z]).parents(".swiper-slider").length &&
          !$(plugins.lightGalleryItem[z]).parents(".slick-slider").length
        ) {
          notCarouselItems.push(plugins.lightGalleryItem[z]);
        }
      }

      plugins.lightGalleryItem = notCarouselItems;

      for (var i = 0; i < plugins.lightGalleryItem.length; i++) {
        initLightGalleryItem(plugins.lightGalleryItem[i]);
      }
    }

    // Dynamic lightGallery
    if (plugins.lightDynamicGalleryItem.length) {
      for (var i = 0; i < plugins.lightDynamicGalleryItem.length; i++) {
        initDynamicLightGallery(plugins.lightDynamicGalleryItem[i]);
      }
    }

    // Custom Toggles
    if (plugins.customToggle.length) {
      for (var i = 0; i < plugins.customToggle.length; i++) {
        var $this = $(plugins.customToggle[i]);

        $this.on(
          "click",
          $.proxy(function (event) {
            event.preventDefault();

            var $ctx = $(this);
            $($ctx.attr("data-custom-toggle")).add(this).toggleClass("active");
          }, $this)
        );

        if ($this.attr("data-custom-toggle-hide-on-blur") === "true") {
          $body.on("click", $this, function (e) {
            if (
              e.target !== e.data[0] &&
              $(e.data.attr("data-custom-toggle")).find($(e.target)).length &&
              e.data.find($(e.target)).length === 0
            ) {
              $(e.data.attr("data-custom-toggle"))
                .add(e.data[0])
                .removeClass("active");
            }
          });
        }

        if ($this.attr("data-custom-toggle-disable-on-blur") === "true") {
          $body.on("click", $this, function (e) {
            if (
              e.target !== e.data[0] &&
              $(e.data.attr("data-custom-toggle")).find($(e.target)).length ===
                0 &&
              e.data.find($(e.target)).length === 0
            ) {
              $(e.data.attr("data-custom-toggle"))
                .add(e.data[0])
                .removeClass("active");
            }
          });
        }
      }
    }

    function customTriangle(section, item) {
      var sectionHeight = section.innerHeight();
      var style =
        sectionHeight / 2 +
        "px" +
        " 0 " +
        sectionHeight / 2 +
        "px " +
        sectionHeight / 5.925 +
        "px";

      item.css({
        "border-width": style,
      });
    }

    var $triangle = $(".bg-triangle"),
      $triangleItem = $(".bg-triangle-item");

    if ($triangle) {
      customTriangle($triangle, $triangleItem);
      $window.on("load resize", function () {
        customTriangle($triangle, $triangleItem);
      });
    }

    var $tringlecustom = $("[data-triangle]");

    if ($tringlecustom.length) {
      createTriangle($tringlecustom);
      $window.on("load resize ", function () {
        createTriangle($tringlecustom);
      });
    }

    function createTriangle(item) {
      for (var i = 0; i < item.length; i++) {
        var $this = $(item[i]),
          param = {
            triangle: $($this.attr("data-triangle")),
            direction: $this.attr("data-triangle-direction"),
            height: $this.innerHeight() / 2,
            width: $this.innerWidth() / 2,
            triangleLength: $this.attr("data-triangle-length"),
          };

        if (param.direction === "left") {
          param.triangle.css({
            "border-width":
              param.height +
              "px " +
              (param.height * param.triangleLength) / 100 +
              "px " +
              param.height +
              "px " +
              " 0px",
            "border-right-color": "inherit",
          });
        }

        if (param.direction === "right") {
          param.triangle.css({
            "border-width":
              param.height +
              "px " +
              " 0px " +
              param.height +
              "px " +
              (param.height * param.triangleLength) / 100 +
              "px ",
            "border-left-color": "inherit",
          });
        }

        if (param.direction === "right") {
          param.triangle.css({
            "border-width":
              param.height +
              "px " +
              " 0px " +
              param.height +
              "px " +
              (param.height * param.triangleLength) / 100 +
              "px ",
          });
        }
      }
    }
  });
}

export const initParallax = () => {
  $?.(".parallax-container:not(.inited)")?.parallax();
};
